import React, { useEffect, useRef, useState } from 'react';
import useAuth from '../../auth/useAuth';

import {
    awaitDelay, getProcessButtons, getDtRowIndex, getError, getImageCircularGenericNew, getLanguageObj, getResponse,
    isUndNullNew, LoadingSection, sendMessageCloseCurrentWindow, settings,
} from '../../helpers/UtilsHelper';
import AccountAdd from './AccountAdd';
import Menu from '../main/Menu';
import Swal from 'sweetalert2';
import { UserClass } from '../../classes/user/userClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';
import { AccountService } from '../../services/accounts/AccountService';

const $ = window?.$;

const { app, collections: dbCollections, colors, firebase, html, icons, images, labels, react, messages, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators, } = firebase?.firestore;
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const currentMethod = 'Accounts - function';

export default function Accounts({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let dataObj = {};
    const auth = useAuth();
    let dtAccountsId = 'dtAccounts';
    const [user, setUser] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [process, setProcess] = useState({ showLoading: true, add: false });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const userMethods = async ({
        e = {},
        userId = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'userMethods';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            e?.preventDefault();

            switch (processType) {
                case 0:
                    setProcess(prev => ({ ...prev, showLoading: true, add: true }));

                    const user_ = UserClass?.getClass();
                    user_.userId = auth?.account?.uid;
                    setUser(user_);

                    await awaitDelay({ delayTime: settings?.timers?.oneSeconds });

                    setShowModal(true);
                    break;
                case 1:
                    setProcess(prev => ({ ...prev, showLoading: true }));
                    await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
                    window.location.href = `/accountDetails/${userId}`;
                    break;
                case -1:
                    //#region show message
                    const msgTextObj = {
                        one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        two: `${labels?.account?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = SwalPropertiesClass?.getClass();
                    swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal?.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                //#region delete accout
                                const token = auth?.account?.tokenVzLaML?.token;
                                preConfirmResponse = await AccountService.delete({ id: userId, token, subMethod: currentMethod });

                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                                $(`#${dtAccountsId}`).DataTable().row(rowIndex).remove().draw(true);

                                preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                                //#endregion delete account
                            } catch (ex) {
                                preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                            }
                            return preConfirmResponse;
                        }
                    };

                    const swalResult = await Swal?.fire({
                        ...swalProperties,
                    });
                    if (swalResult?.isConfirmed && swalResult?.value) {
                        response = swalResult?.value;
                    } else if (swalResult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    //#endregion show message
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtAccountsId}`).DataTable({
                destroy: true,
                data: [],
                order: [[1, 'asc']],
                columns: [
                    { title: labels?.image?.[languageObj?.id], width: '15%', orderable: false },
                    { title: labels?.user?.[languageObj?.id], width: '30%', orderable: true },
                    { title: labels?.firstName?.[languageObj?.id], width: '50%', orderable: true },
                    {
                        title: 'Process',
                        className: 'text-center',
                        width: '5%',
                        orderable: false,
                    },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtAccountsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let methodName = '';
            let rowIndex = 0;
            let description = '';
            //#endregion variables

            //#region process
            $(`#${dtAccountsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndex(dtAccountsId, this, currentMethod)?.result;
                if (!isUndNullNew({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            await userMethods({
                                e: e,
                                userId: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: 1,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'delete':
                            await userMethods({
                                e: e,
                                userId: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: -1,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            }
            );
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let dtRows = [];
            let accounts = [];
            //#endregion variables

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region set dataTable
            response = setDataTable({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set dataTable

            //#region set queryCode
            response = setQueryCode({
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set queryCode

            //#region get data (accounts)
            const token = auth?.account?.tokenVzLaML?.token;
            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid || '' },
                ],
                ordersBy: [
                    { field: dbFields?.userName, values: dbOrdersBy?.asc, },
                ],
                limit: 0,
                path: dbCollections?.accounts
            };

            response = await AccountService.getAll({ dataObj, token, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) return;

            accounts = response?.result || [];

            if (!isUndNullNew({ data: accounts, subMethod: currentMethod })?.result && accounts.length > 0) {
                accounts.map((detaile) => (
                    dtRows.push([
                        getImageCircularGenericNew({
                            alt: 'accountImage',
                            src: detaile?.pictureUrl,
                            subMethod: currentMethod
                        })?.result,
                        detaile.userName,
                        `${detaile?.firstName || ''}, ${detaile?.lastName || ''}`,
                        getProcessButtons({
                            id: detaile?.id,
                            description: detaile?.userName,
                            detailsShow: false,
                            detailsLabel: labels?.detail?.[languageObj?.id],
                            detailsEnabled: false,
                            editShow: true,
                            editLabel: labels?.edit?.[languageObj?.id],
                            editEnabled: true,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            processButtons: [],
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        })?.result,
                    ])
                ))
            }

            $(`#${dtAccountsId}`).DataTable().rows.add(dtRows).draw(true);
            //#endregion get data (users)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    };

    useEffect(() => {
        isMount.current = true;

        getData({
            subMethod: 'form - onLoad',
        });

        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'accounts'} process={'accounts'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.accounts?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.accounts?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className='card border-0 shadow-lg login-card mb-5'>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt='imgAccounts'
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.group} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.accounts?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                                disabled={process?.showLoading}
                                                onClick={(e) => userMethods({ e: e, userId: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btnAddAccount', })}
                                                data-title={labels?.add?.[languageObj?.id]}>
                                                {!process?.add ? (
                                                    <i className={`${icons?.fasFa?.plusCircle} mr-1`} />
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )} {labels?.add?.[languageObj?.id]}
                                            </button>
                                        </div>
                                    </div>

                                    <div className='card-body px-4 pb-4'>
                                        <TableIndex tableId={dtAccountsId} languageObj={languageObj} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* /.container-fluid */}

                    {showModal && (
                        <AccountAdd $={$}
                            auth={auth}
                            user={user}
                            setUser={setUser}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            dtId={dtAccountsId}
                            languageObj={languageObj}
                        />
                    )}
                </section>
                {/* /.content */}
            </div>
        </div>
    );
}